import { render, staticRenderFns } from "./ActivationEmail.vue?vue&type=template&id=6131165e&scoped=true&"
import script from "./ActivationEmail.vue?vue&type=script&lang=ts&"
export * from "./ActivationEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationEmail.vue?vue&type=style&index=0&id=6131165e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6131165e",
  null
  
)

export default component.exports